import { AbstractControl } from "@angular/forms";

export const latLongValidator = (control: AbstractControl): object | null => {
  const urlString: string = control.value;
  const regExp = new RegExp(/^(-?\d*\.?\d{6,9},)+(-?\d+\.?\d{6,9})$/gm);
  if (urlString == '') {
    return null;
  }
  else {
    return (regExp.test(urlString)) ? null : { invalid: true };
  }
}